"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.TelemetryConstant = exports.HttpStatusCode = void 0;
/**
 * @author Siglud <Siglud@gmail.com>
 */
var HttpStatusCode;
(function (HttpStatusCode) {
    HttpStatusCode[HttpStatusCode["OK"] = 200] = "OK";
    HttpStatusCode[HttpStatusCode["CREATED"] = 201] = "CREATED";
    HttpStatusCode[HttpStatusCode["ACCEPTED"] = 202] = "ACCEPTED";
    HttpStatusCode[HttpStatusCode["BAD_REQUEST"] = 400] = "BAD_REQUEST";
    HttpStatusCode[HttpStatusCode["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    HttpStatusCode[HttpStatusCode["FORBIDDEN"] = 403] = "FORBIDDEN";
    HttpStatusCode[HttpStatusCode["NOTFOUND"] = 404] = "NOTFOUND";
    HttpStatusCode[HttpStatusCode["TOOMANYREQS"] = 429] = "TOOMANYREQS";
    HttpStatusCode[HttpStatusCode["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
})(HttpStatusCode = exports.HttpStatusCode || (exports.HttpStatusCode = {}));
class TelemetryConstant {
}
exports.TelemetryConstant = TelemetryConstant;
// the component name of the deployment life cycle
TelemetryConstant.DEPLOY_COMPONENT_NAME = "deploy";
// the component name of the provision life cycle
TelemetryConstant.PROVISION_COMPONENT_NAME = "provision";
// the script component name
TelemetryConstant.SCRIPT_COMPONENT = "script";
//# sourceMappingURL=commonConstant.js.map